<template>
  <div class="page p404">
    <div class="p404__inner container">
      <div class="p404__letters">
        <div class="p404__col">

          <div class="p404__col__wrapper">
            <div class="p404__col__inner">
              <p class="p404__letter">d</p>
              <p class="p404__letter">d</p>
              <p class="p404__letter">d</p>

              <template v-if="isMobile">
                <p class="p404__letter">d</p>
                <p class="p404__letter">d</p>
                <p class="p404__letter">d</p>
              </template>
            </div>

            <div class="p404__col__inner">
              <p class="p404__letter">d</p>
              <p class="p404__letter">d</p>
              <p class="p404__letter">d</p>

              <template v-if="isMobile">
                <p class="p404__letter">d</p>
                <p class="p404__letter">d</p>
                <p class="p404__letter">d</p>
              </template>
            </div>
          </div>

          <p class="p404__digit">4</p>
        </div>
        <div class="p404__col">
          
          <div class="p404__col__wrapper">
            <div class="p404__col__inner">
              <p class="p404__letter">o</p>
              <p class="p404__letter">o</p>
              <p class="p404__letter">o</p>

              <template v-if="isMobile">
                <p class="p404__letter">o</p>
                <p class="p404__letter">o</p>
                <p class="p404__letter">o</p>
              </template>
            </div>

            <div class="p404__col__inner">
              <p class="p404__letter">o</p>
              <p class="p404__letter">o</p>
              <p class="p404__letter">o</p>

              <template v-if="isMobile">
                <p class="p404__letter">o</p>
                <p class="p404__letter">o</p>
                <p class="p404__letter">o</p>
              </template>
            </div>
          </div>

          <p class="p404__digit">0</p>
        </div>
        <div class="p404__col">
          
          <div class="p404__col__wrapper">
            <div class="p404__col__inner">
              <p class="p404__letter">w</p>
              <p class="p404__letter">w</p>
              <p class="p404__letter">w</p>

              <template v-if="isMobile">
                <p class="p404__letter">w</p>
                <p class="p404__letter">w</p>
                <p class="p404__letter">w</p>
              </template>
            </div>

            <div class="p404__col__inner">
              <p class="p404__letter">w</p>
              <p class="p404__letter">w</p>
              <p class="p404__letter">w</p>

              <template v-if="isMobile">
                <p class="p404__letter">w</p>
                <p class="p404__letter">w</p>
                <p class="p404__letter">w</p>
              </template>
            </div>
          </div>

          <p class="p404__digit">4</p>
        </div>

        <div class="p404__back vertical-text">
          <router-link to="/" class="p404__back__link">Go to the homepage</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Page from '@/mixins/Page'

import EventHub from '@/utils/EventHub'

export default {
  name: 'P404',

  mixins: [
      Page
  ],

  components: {

  },

  computed: {

  },

  data() {
    return {
      isMobile: false
    }
  },

  created()
  {
    this.addListeners()
  },

  mounted()
  {
    EventHub.$emit('app:preloading-end')
  },

  destroyed()
  {
    this.removeListeners()
  },

  methods:
  {
    addListeners()
    {
        EventHub.$on('window:resize', this.onResize)
    },

    removeListeners()
    {
        EventHub.$off('window:resize', this.onResize)
    },

    onResize(windowObj)
    {
        if(windowObj.width <= 768)
        {
            this.isMobile = true
        }
        else
        {
            this.isMobile = false
        }
    }
  }
}
</script>

<style lang="stylus">
  .p404
    z-index 98
    position fixed
    height 100vh
    width 100vw
    background #0d0d16

  .p404__inner
    position relative
    height 100%

  .p404__inner.container
    @media(max-width 768px)
      width 100%

  .p404__letters
    position absolute
    width 100%
    padding-left calc(100% / 36)
    padding-right calc(100% / 36)
    // height 100%
    top 50%
    display flex
    flex-direction row
    justify-content space-between
    transform translateY(-50%)

    @media(max-width 768px)
      padding 0

  .p404__col
    position relative

    &:first-child
      .p404__digit
        right -30px

    &:nth-child(2)
      .p404__digit
        left 50%

    &:nth-child(3)
      .p404__digit
        left -30px

  .p404__col__wrapper
    display flex
    flex-direction column
    animation-name letterSlide
    animation-duration 14s
    animation-timing-function linear
    animation-delay 0s
    animation-iteration-count infinite
    will-change transform

  .p404__col__inner

    &:last-of-type
      position absolute
      top 100%
      left 0

  .p404__letter
    font-size 31vw
    font-family 'Sabon'
    text-transform uppercase
    color $grey
    line-height 1

  .p404__digit
    color $grey
    font-size 20px
    font-family 'Sabon'
    position absolute 
    top 50%
    transform translateY(-50%)

  .p404__back
    position absolute
    top 50%
    right 0
    color $grey
    text-transform uppercase
    transform translateY(-50%) rotate(180deg)
    transition opacity 0.5s $ease-out-circ

    @media(max-width 768px)
      right 5%
      background #0d0d16
      padding 20px

      &:hover
        opacity 1

    &:hover
      opacity 0.7

  .p404__back__link
    overflow hidden
    position relative
    display block
    line-height 2

    &:after
        content ''
        position absolute
        bottom 0
        left 0
        width 1px
        height 100%
        background-color $grey
        transform-origin center right
        transform scaleX(1.2) scaleY(1)

@keyframes letterSlide {
  from {
    transform translate3d(0, 0, 0)
  }

  to {
      transform translate3d(0, -100%, 0)
  }
}
</style>